<template lang="pug">
    r-table(
        checkable
        no-data-text='Sin facturas de venta.'
        no-remove
        no-search
        ref='table'
        remind-key='customer-debts-list'
        v-bind='tableProps'
        @detail='submitDetail'
        @selected='submitSelected'
    )
        template( slot='prepend' slot-scope='props' )
            h1.subheading.font-weight-medium.text-uppercase Deuda total: {{ debtTotal | mixFormatCurrency }}
        template( slot='items' slot-scope='props' )
            v-btn( 
                color='success' 
                :disabled='props.disabled || disabled'
                @click='submitMails'
            ) enviar correos &nbsp;
                v-icon mail
        template( slot='actions' slot-scope='props' )
            r-btn-action(
                color='success'
                tooltip='Enviar correo'
                @click='submitMail(props)'
            )
                v-icon mail
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { RBtnAction, RTable } from '@/components/reusable_components/next'
    import CurrencyMixin from '@/mixins/reusable_mixins/CurrencyUtils'
    import TranslatorService from '@/services/translator'
    //
    import SlCustomerSendEmailWithDebtsModel from '@/models/Sale/SlCustomerSendEmailWithDebts'
    import SlSaleInvoiceModel from '@/models/Sale/SlSaleInvoice'
    import SlCustomerDebtFilters from '@/views/Sale/SlCustomer/SlCustomerDebtFilters'
    import SlCustomerDebtHeaders from '@/views/Sale/SlCustomer/SlCustomerDebtHeaders'
    //
    export default {
        components: {
            RBtnAction,
            RTable,
        },
        computed: {

            /**
             *
             */
            ...mapState('SnackbarModalModule', [
                'responseConfirm',
            ]),

            /**
             * 
             */
            selectedCustomers() {
                return {
                    sl_customers: this.selected.map(this.mapCustomer),
                }
            },

            /**
             *
             */
            tableProps() {
                return {
                    attachParams: {
                        debt_total: 1,
                    },
                    filters: SlCustomerDebtFilters,
                    headers: SlCustomerDebtHeaders,
                    service: SlSaleInvoiceModel,
                    paramFilter: {
                        receivable: 1,
                    },
                    parser: this.parser,
                }
            },
        },
        data() {
            return {
                disabled: true,
                selected: [],
                debtTotal: 0,
            }
        },
        methods: {

            /**
             *
             */
            ...mapActions('MenuesModule', [
                'setItemsTopBar',
                'setTitleTopBar',
            ]),

            /**
             *
             */
            ...mapActions('SnackbarModalModule', [
                'resetSnackbarState',
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(SlSaleInvoiceModel, error.response.data))
            },

            /**
             * 
             */
            mapCustomer(item) {
                return item.id
            },

            /**
             * 
             */
            parser(res) {

                this.debtTotal = res.debt_total || 0

                let group = res.data
                    .reduce((arr, invoice) => {
                        if (!arr[invoice.sl_customer_id]) arr[invoice.sl_customer_id] = []
                        arr[invoice.sl_customer_id].push(invoice)
                        return arr
                    }, [])
                    .filter(invGroup => invGroup !== null || invGroup.length !== 0)
                    .map(invGroup => {
                        let payDate = null
                        let status = 'Pendiente'
                        let is_send = false
                        let total = 0
                        invGroup.forEach(inv => {
                            if (!payDate) {
                                payDate = inv.account_receivable.pay_date
                            } else {
                                if (
                                    inv.account_receivable.pay_date< payDate
                                    
                                )
                                    payDate = inv.account_receivable.pay_datepayDate
                            }
                            if (inv.status === 'Atrasado') status = inv.status
                            total += inv.account_receivable.amount
                            is_send = Boolean(inv.qty_times_sent_to_provider)
                        })
                        total = total
                        return {
                            id: invGroup[0].sl_customer_id,
                            customerName: invGroup[0].sl_customer.alias_name,
                            customerRut: invGroup[0].sl_customer.rut,
                            payDate,
                            invoiceCount: invGroup.length,
                            status,
                            total,
                            invoices: invGroup,
                            is_send, 
                        }
                    })

                res.data = group

                console.log(res.data)
                    
                return res
            },

            /**
             *
             */
            refresh() {
                this.$refs.table.refresh()
            },

            /**
             *
             */
            submitDetail(event) {
                this.$router.push({
                    name: 'customer-update',
                    params: {
                        id: event.item.id
                    }
                })
            },

            /**
             *
             */
            submitMail(event) {

                //
                this.setWarningSnackbar({
                    title: '¿Esta seguro en enviar un correo electrónico al cliente seleccionado?',
                    message: 'Una vez enviado no se puede cancelar.',
                    confirm: 'enviar',
                })

                //
                this.selected = [event.item]
            },
            
            /**
             *
             */
            submitMails() {
                this.setWarningSnackbar({
                    title: '¿Esta seguro en enviar un correo electrónico al los clientes seleccionados?',
                    message: 'Una vez enviado no se puede cancelar.',
                    confirm: 'enviar a todos',
                })
            },

            /**
             *
             */
            successMail() {
                this.setSuccessSnackbar('Correo electrónico enviado exitosamente.')
            },

            /**
             *
             */
            successMails() {
                this.setSuccessSnackbar('Correos electrónicos enviados exitosamente.')
            },

            /**
             * 
             */
            submitSelected(event) {
                this.disabled = event.selected.length < 1
                this.selected = event.selected
            },

            /**
             *
             */
            toMail() {
                return new SlCustomerSendEmailWithDebtsModel(this.selectedCustomers)
                    .save()
                    .then(this.refresh)
                    .finally(this.resetSnackbarState)
                    .then(this.successMail)
                    .catch(this.error)
            },

            /**
             *
             */
            toMails() {
                return new SlCustomerSendEmailWithDebtsModel(this.selectedCustomers)
                    .save()
                    .then(this.refresh)
                    .finally(this.resetSnackbarState)
                    .then(this.successMails)
                    .catch(this.error)
            },
        },
        mixins: [CurrencyMixin],
        watch: {

            /**
             *
             */
            responseConfirm(val) {
                switch(val) {
                    case 'enviar': return this.toMail()
                    case 'enviar a todos': return this.toMails()
                }
            }
        },
        mounted() {
            this.setTitleTopBar('Cuentas por cobrar')
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('VIEW_ALL_CUSTOMER_ACCOUNT_RECEIVABLE')) ctx.$router.push('/')
            })
        },
    }
</script>
